<div class="background-login d-flex align-items-center justify-content-center">
  <div class="container-fluid">
    <div class="row align-items-center justify-content-center">
      <div class="col-sm-8 col-md-11 col-lg-10 col-xl-7 wrapper">
        <div class="row">
          <div class="col-md-6 login order-2 order-md-1">
            <header class="header">
              <a routerLink="" href="#" class="header-item">
                <span class="material-icons"> keyboard_backspace </span>
                Voltar
              </a>
            </header>
            <h1 class="login-title">Redefinir senha</h1>
            <p class="login-subtitle">
              Use pelo menos 8 caracteres, sendo 1 letra maiúscula, 1 minúscula
              e 1 numero. Escolha uma senha forte e evite utilizá-la em outras
              contas.
            </p>
            <form
              [formGroup]="newPasswordForm"
              class="login-form"
              (ngSubmit)="newPassword()"
            >
              <div>
                <div class="login-form-item form-group">
                  <label class="login-form__label" for="password"
                    >Sua nova senha</label
                  >
                  <div class="input-group input-group__password">
                    <input
                      #password
                      [type]="fieldTextType ? 'text' : 'password'"
                      id="password"
                      type="password"
                      class="login-form-input form-control"
                      placeholder="Insira sua nova senha"
                      name="password"
                      ngModel
                      required
                      formControlName="password"
                    />
                    <button
                      type="button"
                      class="btn-icon"
                      (click)="toggleFieldTextType()"
                    >
                      <span class="material-icons">{{ changeIcon() }}</span>
                    </button>
                  </div>
                  <div
                    *ngIf="
                      (newPasswordForm.get('password').invalid &&
                        newPasswordForm.get('password').touched) ||
                      newPasswordForm.get('confirmPassword').dirty
                    "
                    class="message-wrapper"
                  >
                    <span
                      *ngIf="newPasswordForm.get('password').errors?.required"
                      class="text-danger"
                      >A senha é um campo obrigatório.</span
                    >
                    <span
                      *ngIf="newPasswordForm.get('password').errors?.minlength"
                      class="text-danger"
                      >Informe uma senha com, ao menos, 8 caracteres.</span
                    >
                    <div
                      *ngIf="newPasswordForm.get('password').errors?.pattern"
                      class="text-danger"
                    >
                      A senha deve e que contenha pelo menos conter 1 caracter
                      especial e 1 letra maiúscula.
                    </div>
                  </div>
                </div>
                <div class="login-form-item form-group">
                  <label class="login-form__label" for="password2"
                    >Repita a nova senha</label
                  >
                  <div class="input-group input-group__password">
                    <input
                      #password
                      [type]="fieldTextTypeConfirm ? 'text' : 'password'"
                      id="password2"
                      type="password"
                      class="login-form-input form-control"
                      [class.is-invalid]="
                        newPasswordForm.get('confirmPassword').invalid &&
                        newPasswordForm.get('confirmPassword').touched
                      "
                      placeholder="Insira sua nova senha novamente"
                      name="password2"
                      ngModel
                      required
                      formControlName="confirmPassword"
                    />
                    <button
                      type="button"
                      class="btn-icon"
                      (click)="toggleFieldTextTypeConfirm()"
                    >
                      <span class="material-icons">{{
                        changeIconConfirm()
                      }}</span>
                    </button>
                  </div>
                  <div
                    *ngIf="
                      (newPasswordForm.get('confirmPassword').invalid &&
                        newPasswordForm.get('confirmPassword').touched) ||
                      newPasswordForm.get('confirmPassword').dirty
                    "
                    class="message-wrapper"
                  >
                    <span
                      *ngIf="
                        newPasswordForm.get('confirmPassword').errors?.required
                      "
                      class="text-danger"
                      >Digita a Senha Novamente é obrigatório.</span
                    >
                    <span
                      *ngIf="
                        newPasswordForm.get('confirmPassword').errors?.mustMatch
                      "
                      class="text-danger"
                      >Senha não confere.</span
                    >
                  </div>
                </div>
                <div class="login-button-container">
                  <button
                    type="submit"
                    [disabled]="!newPasswordForm.valid"
                    class="btn btn-info"
                  >
                    CONFIRMAR
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-6 image order-1 order-md-2">
            <img
              src="./../../../assets/images/logo-nina.svg"
              alt="Logo da Nina"
              class="nina-logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
